import { Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { filter, find, pick } from 'lodash-es';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { TooltipTranslationService } from '~shared/translations';
import { Club, Country, Customer } from '~core/models';
/**
 * Displays the customer merge process page.
 */
@Component({
  selector: 'app-merge-customer-data',
  templateUrl: 'merge-customer-data.component.html',
  styleUrls: ['../../merge-customer.component.scss']
})
export class MergeCustomerDataComponent implements OnInit, OnDestroy {
  @Input() public id: string;
  @Input() public selectedClub: Club;
  @Input() public customer: Array<any>;
  @Input() public combinedCustomer: Customer;
  @Input() public type: string;
  @Input() public countries: Array<Country>;
  @Input() public viewOnly: boolean = false;

  constructor(
    public tooltipTranslations: TooltipTranslationService,
    public tablesTranslations: TablesTranslations,
    @Inject(LOCALE_ID) public locale: string,
  ) { }

  public ngOnInit(): void { }

  public ngOnDestroy(): void { }

  /**
   * Returns the object with only the provided keys
   */
  setDragData(data: any, keys: Array<string>): any {
    return pick(data, keys);
  }

  /**
   * Returns the age of the user
   */
  public getAge(birthday: any): any {
    const today = new Date();
    const birthDate = new Date(birthday);
    const m = today.getMonth() - birthDate.getMonth();
    let age = today.getFullYear() - birthDate.getFullYear();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }


  /**
   * Checks if data already exists
   */
  public checkIfExists(data: any, instance: string): boolean {
    if (!this.viewOnly) {
      const dataSet = this.combinedCustomer[instance];
      if (Array.isArray(dataSet)) {
        return find(dataSet, { id: data.id });
      } else if (instance === 'birthday') {
        return data?.date.toISOString() === dataSet?.date.toISOString();
      } else {
        return dataSet === data;
      }
    } else {
      return true;
    }
  }

  /**
   * Checks if name already exists
   */
  public checkIfNameExists(data: any, instances: Array<string>): boolean {
    if (!this.viewOnly) {
      const arr = [];
      instances.forEach(instance => {
        if (instance === 'salutation') {
          arr.push(data[instance]?.value === this.combinedCustomer[instance]?.value);
        } else {
          arr.push(data[instance] === this.combinedCustomer[instance]);
        }
      });
      return arr.every(el => el === true);
    } else {
      return true;
    }
  }

  /**
   * Retrieves the addresses
   */
  public getAddresses(type?: string): Array<any> {
    if (type) {
      return filter(this.customer[0].addresses, el => el.type === type);
    } else {
      return filter(this.customer[0].addresses, el => el.type !== 'standard');
    }
  }

}
